var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var Share20 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '20px' : _c, _d = _a.width, width = _d === void 0 ? '20px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 20 20", xmlnsXlink: "http://www.w3.org/1999/xlink", style: svgStyle },
            React.createElement("desc", null, "Created with Sketch."),
            React.createElement("g", { id: "Share_20_svg__Icons/Share/20", stroke: "none", strokeWidth: 1, fillRule: "evenodd" },
                React.createElement("g", { id: "Share_20_svg__Icons/Share/16-Copy", transform: "translate(4.000000, 1.000000)", fillRule: "nonzero" },
                    React.createElement("polygon", { id: "Share_20_svg__Path", points: "6.45456865 1.88157895 6.45456865 13 5.54543135 13 5.54543135 1.88157895 0.606091527 7.45754917 0 6.77333864 6 0 12 6.77333864 11.3939085 7.45754917" }),
                    React.createElement("path", { d: "M1,17 L11,17 L11,10 L12,10 L12,18 L11,18 L1,18 L0,18 L0,10 L1,10 L1,17 Z", id: "Share_20_svg__Combined-Shape" }))))));
};
Share20.displayName = 'Share20';
export default Share20;
//# sourceMappingURL=share-20.js.map